import { render, staticRenderFns } from "./PointsPos.vue?vue&type=template&id=4a538aba&scoped=true"
import script from "./PointsPos.vue?vue&type=script&lang=js"
export * from "./PointsPos.vue?vue&type=script&lang=js"
import style0 from "./PointsPos.vue?vue&type=style&index=0&id=4a538aba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a538aba",
  null
  
)

export default component.exports